(function () {
  if (window.__aspEarnPointsLoaded) return;
  window.__aspEarnPointsLoaded = true;

  var applying = false;

  function cfg() {
    try {
      return (
        (window.Rivo &&
          Rivo.loy_config &&
          Rivo.loy_config.frontend &&
          Rivo.loy_config.frontend.potential_points &&
          Rivo.loy_config.frontend.potential_points.order_placed) ||
        null
      );
    } catch (e) {
      return null;
    }
  }

  function rate() {
    var r = Number(window.Shopify && Shopify.currency && Shopify.currency.rate);
    return r > 0 ? r : 1;
  }

  function pointsFromCents(cents) {
    var c = cfg();
    if (!c || !c.enabled) return null;
    var amount = Number(cents) / 100 / rate();
    if (!isFinite(amount) || amount < 0) return null;
    amount = Math.round(amount * 100) / 100;
    var base = Number(c.currency_base_amount) || 1;
    var mult = Number(c.points_amount) || 1;
    if (c.points_type === 'fixed') return Math.max(0, Math.floor(mult));
    return Math.max(0, Math.floor((amount / base) * mult));
  }

  function amountEl() {
    return document.querySelector(
      '#loy-potential-points .order-placed-potential-points-amount, span.order-placed-potential-points-amount'
    );
  }

  function setPoints(n) {
    var el = amountEl();
    if (!el || n == null) return false;
    if (String(el.textContent).trim() === String(n)) return true;
    applying = true;
    el.textContent = String(n);
    applying = false;
    return true;
  }

  function fromVariant(variant) {
    if (!variant || variant.price == null) return;
    var n = pointsFromCents(variant.price);
    if (n != null) setPoints(n);
  }

  function currentCents() {
    var product = window.Rivo && Rivo.common && Rivo.common.product;
    if (product && product.price != null) return Number(product.price);
    var form = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"]');
    var id = form && form.value;
    if (!id || !window.meta || !meta.product || !meta.product.variants) return null;
    for (var i = 0; i < meta.product.variants.length; i++) {
      if (String(meta.product.variants[i].id) === String(id)) {
        return Number(meta.product.variants[i].price);
      }
    }
    return null;
  }

  function apply() {
    if (!cfg()) return false;
    if (!amountEl()) return false;
    var cents = currentCents();
    if (cents == null) return false;
    var n = pointsFromCents(cents);
    if (n == null) return false;
    return setPoints(n);
  }

  function onVariantChange(event) {
    var detail = event && event.detail;
    var variant = detail && (detail.variant || detail);
    if (variant && variant.price != null) fromVariant(variant);
    else apply();
  }

  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('theme:variant:change', onVariantChange);

  var tries = 0;
  var timer = window.setInterval(function () {
    tries += 1;
    if (apply() || tries > 60) window.clearInterval(timer);
  }, 250);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);

  var root = document.documentElement;
  var mo = new MutationObserver(function () {
    if (applying) return;
    apply();
  });
  mo.observe(root, { childList: true, subtree: true, characterData: true });
})();
